
















import { Component, Vue, Emit } from "vue-property-decorator";

import config from "../config";
import CommonUtil from "../utils/CommonUtil";
import authService from "../services/AuthService";
import securityService from "../services/SecurityService";

@Component
export default class Login extends Vue {
  error: string | string[] = "";

  created() {
    const { status } = this.$route.query;
    if (status === "success") {
      this.error = "";
      authService.getAuthToken().then(token => {
        this.saveAuthenticated();
      });
    } else if (status === "unauthorized") {
      this.error = "This email address is not authorized";
    } else {
      this.error = "";
    }
  }

  @Emit("authenticated")
  saveAuthenticated() {
    this.$router.push("/");
  }

  handleLogin(): void {
    authService.authRequest();
  }
}
